module.exports = __webpack_public_path__ + "static/media/mass-result.669107fc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/MassTest/mass-result.mp4
// module id = 3634
// module chunks = 0